import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../utils/mobileUtils';
import { connect } from 'react-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';
import $ from 'jquery';
import { withRouter } from 'react-router';
import { ThemeProvider } from 'styled-components';
import TopBar from './common/top-bar/TopBar';
import CustomMenu from './common/menu/CustomMenu';
import MessageAlert from './common/messageAlert/MessageAlert';
import * as accountActions from '../actions/accountActions';
import * as classroomActions from '../actions/classroom/classroomActions';
import * as drawerActions from '../actions/drawerActions';
import * as errorActions from '../actions/errorActions';
import * as customerTranslationsActions from '../actions/customerTranslationsActions';
import { DRAWER_CONTENTS, ROLE, ROUTES, SIZE, PLATFORM_DEFAULT, TABS_CONSTANTS } from '../const';
import routerHistory from '../routerHistory';

import DrawerContainer from './DrawerContainer';
import CreateAssignmentsContent from './drawer-contents/CreateAssignmentsContent';
import SmartLoader from './common/SmartLoader';
import UserProfile from './user/profile/UserProfile';
import EditAssignmentsContentPanel from './drawer-contents/EditAssignmentsContentPanel';
import AssignmentsStudentsContentPanel from './drawer-contents/AssignmentsStudentsContentPanel';
import NewLessonPanel from './drawer-contents/NewLessonPanelContent';
import StudentTaskPanel from './drawer-contents/TaskPanel/StudentTaskPanel';
import InstructorTaskPanel from './drawer-contents/TaskPanel/InstructorTaskPanel';
import NewContentPanel from './drawer-contents/NewClassroomContentPanel';
import ResourcesPreviewPanelContent from './drawer-contents/ResourcesPreviewPanelContent';
import RevealsContainer from './RevealsContainer';
import { getLogger } from '../services/logger';
import * as connectionActions from '../actions/connectionActions';
import * as contentActions from '../actions/contentActions';
import { isElectronApp } from '../services/crossPlatform/crossPlatformService';
import InactivityReveal from './classroom/reveal/InactivityReveal';
import DiscussionPanel from './drawer-contents/DiscussionPanel';
import AssignContentPanel from './drawer-contents/AssignContentPanel';
import AddUserToClassroom from './classroom/students/AddUsers/AddUserToClassroom';
import AddUserToTask from './classroom/students/AddUsers/AddUserToTask';
import SelectStudentsForAnalytics from './ClassRoomBasicAnalytics/SelectStudentsForAnalytics';
import CookieConsent from './common/cookieConsent/CookieConsent';
import '../utils/allSettled_polyfill';
import CookieMenu from './common/cookieConsent/CookieMenu';
import SelectGoogleCourse from './drawer-contents/SelectGoogleCourse';
import NeaeAdaptationsPanel from './drawer-contents/NeaeAdaptationsPanel';
import {
  getConsentCookie,
  getAnalyticsCookie,
  getMeetCookie,
  removeAnalyticsGenericCookies,
  removeMeetGenericCookies,
  getVideoCookie
} from '../utils/cookieUtils';
import { initCalendar } from '../utils/google/GCalendarUtils';
import { NETEX_INFRA, GTM_ID } from '../config_module';
import TagManager from 'react-gtm-module';
import { isClassroomRolePending, resolveRoleForPath } from '../utils/classroomRoleUtils';

const DEFAULT_MENU_CLASS = 'left-menu';
const HIDDEN_MENU_CLASS = 'left-menu hidden';
const SHOW_MENU_BACKGROUND_CLASS = 'show';
const HIDDEN_MENU_BACKGROUND_CLASS = 'hidden';

const debug = getLogger('AppWrapper');

window.d = debug;

class AppWrapper extends React.Component {
  state = {
    loading: true,
    showCookiesConsent: false,
    userId: '',
    synchronizedOnStart: false,
    theme: createTheme({
      typography: {
        useNextVariants: true,
        fontFamily: 'Lato, DefaultLato sans-serif'
      },
      palette: {
        primary: {
          50: '#eaf2f5',
          100: '#eaf2f5',
          200: '#12abe3',
          300: '#12abe3',
          400: '#12abe3',
          500: '#12abe3',
          600: '#12abe3',
          700: '#12abe3',
          800: '#12abe3',
          900: '#12abe3',
          A100: '#12abe3',
          A200: '#12abe3',
          A400: '#12abe3',
          A700: '#12abe3'
        },
        secondary: {
          50: '#f0f0f3',
          100: '#efefef',
          200: '#ddd',
          300: '#ddd',
          400: '#ddd',
          500: '#ddd',
          600: '#999',
          700: '#666',
          800: '#333',
          900: '#333',
          A100: '#999',
          A200: '#666',
          A400: '#666',
          A700: '#333'
        }
      }
    })
  };

  componentDidMount() {
    const {
      classroomActions,
      accountActions,
      connectionActions,
      customerTranslationsActions,
      trackingIdGAnalytics,
      googleMeetClientId,
      user
    } = this.props;

    const shouldShowCookiesConsentPopup = () => {
      const isVideoCookieSet = !_.isNil(getVideoCookie(user));
      const isAnalyticsCookieSet = !_.isNil(getAnalyticsCookie(user));
      const isMeetCookieSet = !_.isNil(getMeetCookie(user));
      const isLaunchComponent = window.location.pathname === '/launch';

      return (
        !isLaunchComponent &&
        (Boolean(!isVideoCookieSet) ||
          Boolean(!isAnalyticsCookieSet && (NETEX_INFRA || !_.isEmpty(trackingIdGAnalytics))) ||
          Boolean(!isMeetCookieSet && googleMeetClientId))
      );
    };

    accountActions.getUserData();
    this.checkForRouteUpdate();
    accountActions.getCostumerConfiguration();
    accountActions.loadUserConfiguration();

    const analyticsCookieConsent = getAnalyticsCookie(user) === 'true';
    if (analyticsCookieConsent && NETEX_INFRA && GTM_ID) {
      const tagManagerArgs = {
        gtmId: GTM_ID
      };
      TagManager.initialize(tagManagerArgs);
    }

    const meetCookieConsent = getMeetCookie(user) === 'true';
    if (googleMeetClientId && meetCookieConsent) {
      initCalendar();
    }

    setTimeout(() => {
      $('#smartLoader')
        .removeClass('active')
        .removeClass('opaque');
      $('#smartLoader-loader').removeClass('active');
      this.setState({ loading: false });
    }, 1000);
    classroomActions.getActiveClassroomData();

    if (isElectronApp() && window.require) {
      const ipcRenderer = window.require('electron').ipcRenderer;
      ipcRenderer.on('reconnection', () => {
        connectionActions.manualTryToConnect(true);
      });
      ipcRenderer.send('app-has-update', {});
    }

    if (shouldShowCookiesConsentPopup()) {
      this.setState({ showCookiesConsent: true });
    }

    customerTranslationsActions.getCustomerTranslations();
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (
      (nextProps.drawer.open === false && nextProps.drawer.content === DRAWER_CONTENTS.CREATE_COOKIES_PANEL) ||
      nextProps.user._id !== state.userId
    ) {
      removeAnalyticsGenericCookies();
      removeMeetGenericCookies();
      return {
        showCookiesConsent: getConsentCookie(nextProps.user) !== 'true' && window.location.pathname !== '/launch',
        userId: nextProps.user._id
      };
    }
    return {};
  }

  getSnapshotBeforeUpdate(prevProps) {
    const { themeColors } = this.props;
    if (themeColors.primary !== prevProps.themeColors.primary) {
      this.updateMuiTheme(themeColors.primary);
    }
    return null;
  }

  updateMuiTheme = primaryColor => {
    this.setState({
      theme: createTheme({
        typography: {
          useNextVariants: true,
          fontFamily: 'Lato, DefaultLato sans-serif'
        },
        palette: {
          primary: {
            50: primaryColor,
            100: primaryColor,
            200: primaryColor,
            300: primaryColor,
            400: primaryColor,
            500: primaryColor,
            600: primaryColor,
            700: primaryColor,
            800: primaryColor,
            900: primaryColor,
            A100: primaryColor,
            A200: primaryColor,
            A400: primaryColor,
            A700: primaryColor
          },
          secondary: {
            50: '#f0f0f3',
            100: '#efefef',
            200: '#ddd',
            300: '#ddd',
            400: '#ddd',
            500: '#ddd',
            600: '#999',
            700: '#666',
            800: '#333',
            900: '#333',
            A100: '#999',
            A200: '#666',
            A400: '#666',
            A700: '#333'
          }
        }
      })
    });
  };

  checkForRouteUpdate() {
    const { accountActions, params, location, routes, router } = this.props;

    if (!router.location || router.location.pathname !== location.pathname) {
      accountActions.setApplicationLocation(location);
      accountActions.setApplicationParams(params);
      accountActions.setApplicationHistory(routes);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      layoutSettings,
      loadedSchoolInfo,
      loaded,
      role,
      accountActions,
      user,
      customer,
      platformName,
      classrooms,
      contentActions,
      enableHomeView,
      isJailed
    } = this.props;

    const { synchronizedOnStart } = this.state;

    const pathName = routerHistory.getCurrentLocation().pathname;
    if (loadedSchoolInfo && loaded && layoutSettings) {
      if (pathName === ROUTES.LOGIN) {
        routerHistory.push(ROUTES.LOGIN);
      } else if (!this.isRouteAccessible(pathName, layoutSettings) && pathName !== ROUTES.ROOT) {
        routerHistory.push(ROUTES.ERROR);
      } else if (pathName === ROUTES.ROOT) {
        const userSettings =
          role === ROLE.INSTRUCTOR
            ? layoutSettings.teacherSettings
            : role === ROLE.COINSTRUCTOR
            ? layoutSettings.coinstructorSettings
            : layoutSettings.studentSettings;
        accountActions.redirectToHomeOrClassroom(user._id, ROUTES[userSettings.userSections.menuRoutes[0]]);
      }
    }

    document.title = platformName || PLATFORM_DEFAULT;

    const finishedClassroomsFetch = prevProps.classrooms.fetching && !classrooms.fetching;
    if (isElectronApp() && window.require && !synchronizedOnStart && finishedClassroomsFetch) {
      this.setState({ synchronizedOnStart: true });
      contentActions.synchronizeContentDownload(user._id);
      if (!enableHomeView && !isJailed) {
        accountActions.redirectToHomeOrClassroom(user._id);
      }
    }
    this.checkForRouteUpdate();
  }

  getConstantsRoutes(constants, inClassroom) {
    return constants.map(constant => {
      return inClassroom ? ROUTES.REGEXP[constant] : ROUTES[constant];
    });
  }

  checkValidClassroomRoute(userSettings, pathname) {
    const routesRegexp = this.getConstantsRoutes(userSettings.classroomSections.menuRoutes, true);
    for (let i = 0; i < routesRegexp.length; ++i) {
      if (routesRegexp[i] && new RegExp(routesRegexp[i]).test(pathname)) {
        return true;
      }
    }
    return false;
  }

  resolveEffectiveRole(pathname) {
    const { role, activeClassrooms, selectedClassroom, classroomsFetching } = this.props;

    if (isClassroomRolePending(pathname, activeClassrooms, selectedClassroom, classroomsFetching)) {
      return null;
    }

    return resolveRoleForPath(pathname, role, activeClassrooms, selectedClassroom);
  }

  isRouteAccessible(pathname, layoutSettings) {
    const { errorActions } = this.props;
    const role = this.resolveEffectiveRole(pathname);

    if (role === null) {
      return true;
    }

    let result = false;
    if (layoutSettings) {
      const userSettings =
        role === ROLE.INSTRUCTOR
          ? layoutSettings.teacherSettings
          : role === ROLE.COINSTRUCTOR
          ? layoutSettings.coinstructorSettings
          : layoutSettings.studentSettings;
      if (_.includes(this.getConstantsRoutes(userSettings.userSections.menuRoutes, false), pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.CLASSROOM_BOOK_LIBRARY).test(pathname)) {
        result = true;
      } else if (this.checkValidClassroomRoute(userSettings, pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.CLASSROOM_BOOK).test(pathname) || pathname === ROUTES.PROFILE) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.ERROR).test(pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.REDIRECT_CONTENT).test(pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.ANALYTICS).test(pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.REGEXP.STUDENT_ANNOTATIONS).test(pathname)) {
        const { classroomTabs } = this.props;
        result = role === ROLE.STUDENT && (classroomTabs || []).includes(TABS_CONSTANTS.STUDENT_ANNOTATIONS);
      } else if (new RegExp(ROUTES.REGEXP.SEARCH_RESULTS).test(pathname)) {
        result = true;
      } else if (new RegExp(ROUTES.TASKS).test(pathname)) {
        result = true;
      }
    } else {
      errorActions.setErrorData('403', 'errorPage.description.notAllowed');
    }
    return result;
  }

  renderMenuBackground() {
    const { menuIsOpen } = this.props;
    let menuBackgroundClass = !menuIsOpen ? HIDDEN_MENU_BACKGROUND_CLASS : SHOW_MENU_BACKGROUND_CLASS;
    return (
      <div id="menu-background" className={menuBackgroundClass}>
        &nbsp;
      </div>
    );
  }

  renderMenu() {
    const { menuIsOpen, router, role } = this.props;
    let menuClass = !role || !menuIsOpen ? HIDDEN_MENU_CLASS : DEFAULT_MENU_CLASS;
    return (
      <div className={menuClass}>
        <CustomMenu route={router.location.pathname} />
      </div>
    );
  }

  render() {
    const {
      children,
      menuIsOpen,
      colors,
      loaded,
      loadedSchoolInfo,
      connectionStatus,
      layoutSettings,
      role,
      drawerActions,
      drawer,
      activeLoader,
      router,
      googleMeetClientId,
      jitsiDomain
    } = this.props;
    const pathName = routerHistory.getCurrentLocation().pathname;
    const { loading, theme } = this.state;
    if (
      !loadedSchoolInfo ||
      !loaded ||
      !this.isRouteAccessible(pathName, layoutSettings) ||
      pathName === ROUTES.ROOT
    ) {
      return (
        <ThemeProvider theme={colors}>
          <InactivityReveal />
        </ThemeProvider>
      ); // TODO:  Return loading maybe
    }
    let visible = !loading ? 'visible' : '';

    let appWrapperClassName = menuIsOpen && this.appWidth > SIZE.SMALL ? 'compact' : '';
    const childrenWrapperClassName =
      !connectionStatus.general || !connectionStatus.rabbit ? 'children-wrapper offline' : 'children-wrapper';
    const mobileSheet = this.getMobileSheetComponent();
    return (
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={colors}>
          <div id="main-app-wrapper" className="main-app-wrapper">
            {this.renderMenu()}
            {this.renderMenuBackground()}
            <RevealsContainer />

            <div id="main-app-wrapper-content" className={appWrapperClassName}>
              <TopBar visible={visible} googleMeetClientId={googleMeetClientId} jitsiDomain={jitsiDomain} />
              <div className={childrenWrapperClassName}>{router.inProfile ? <UserProfile /> : children}</div>
              <Media query={MOBILE_MEDIA_QUERY}>
                {isMobile =>
                  isMobile && mobileSheet ? (
                    // Mobile: these panels are bottom sheets, not the right drawer
                    drawer.open && mobileSheet
                  ) : (
                    <Drawer anchor="right" open={drawer.open} onClose={drawerActions.closeDrawerAndRemoveContent}>
                      <DrawerContainer backgroundColor={colors.backgroundSecondary}>
                        {this.getDrawerChildComponent()}
                      </DrawerContainer>
                    </Drawer>
                  )
                }
              </Media>
            </div>
            <MessageAlert />
            {this.state.showCookiesConsent && (
              <CookieConsent platformName={this.props.platformName} cookiesInfoUrl={this.props.cookiesInfoUrl} />
            )}
            <SmartLoader active={activeLoader} />
          </div>
        </ThemeProvider>
      </MuiThemeProvider>
    );
  }

  // Drawer contents with a bottom sheet layout on mobile; null keeps the right drawer
  getMobileSheetComponent() {
    const { drawer } = this.props;

    switch (drawer.content) {
      case DRAWER_CONTENTS.ASSIGN_STUDENTS:
        return <AssignContentPanel variant="sheet" />;
      case DRAWER_CONTENTS.LESSON_CREATE:
        return <NewLessonPanel variant="sheet" bookId={this.props.params.idBook} />;
      case DRAWER_CONTENTS.UNIT_CREATE:
        return <NewContentPanel variant="sheet" creatingUnit={true} bookId={this.props.params.idBook} />;
      case DRAWER_CONTENTS.CONTENT_CREATE:
        return <NewContentPanel variant="sheet" />;
      default:
        return null;
    }
  }

  getDrawerChildComponent() {
    const { drawer } = this.props;

    switch (drawer.content) {
      case DRAWER_CONTENTS.CREATE_DISCUSSIONS_PANEL:
        return <DiscussionPanel />;
      case DRAWER_CONTENTS.CREATE_ASSIGNMENTS_FROM_BOOK:
        return <CreateAssignmentsContent />;
      case DRAWER_CONTENTS.DETAIL_ASSIGNMENTS:
        return <EditAssignmentsContentPanel />;
      case DRAWER_CONTENTS.STUDENTS_ASSIGNMENT:
        return <AssignmentsStudentsContentPanel />;
      case DRAWER_CONTENTS.ASSIGN_STUDENTS:
        return <AssignContentPanel />;
      case DRAWER_CONTENTS.LESSON_CREATE:
        return <NewLessonPanel bookId={this.props.params.idBook} />;
      case DRAWER_CONTENTS.UNIT_CREATE:
        return <NewContentPanel creatingUnit={true} bookId={this.props.params.idBook} />;
      case DRAWER_CONTENTS.CONTENT_CREATE:
        return <NewContentPanel />;
      case DRAWER_CONTENTS.STUDENT_TASK:
        return <StudentTaskPanel />;
      case DRAWER_CONTENTS.INSTRUCTOR_TASK:
        return <InstructorTaskPanel />;
      case DRAWER_CONTENTS.ADD_NEW_USER:
        return <AddUserToClassroom />;
      case DRAWER_CONTENTS.ADD_USERS_TO_TASK:
        return <AddUserToTask />;
      case DRAWER_CONTENTS.CREATE_COOKIES_PANEL:
        return <CookieMenu />;
      case DRAWER_CONTENTS.CREATE_PROFILE_PANEL:
        return <UserProfile closable />;
      case DRAWER_CONTENTS.SELECT_COURSE_GOOGLE:
        return <SelectGoogleCourse />;
      case DRAWER_CONTENTS.VIEW_STUDENT_PROFILE_PANEL:
        return <UserProfile closable />;
      case DRAWER_CONTENTS.RESOURCES_PREVIEW:
        return <ResourcesPreviewPanelContent />;
      case DRAWER_CONTENTS.SELECT_STUDENTS_FOR_ANALYTICS:
        return <SelectStudentsForAnalytics />;
      case DRAWER_CONTENTS.NEAE_ADAPTATIONS_PANEL:
        return <NeaeAdaptationsPanel />;

      default:
        return <div />;
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppWrapper));

AppWrapper.propTypes = {
  platformName: PropTypes.string,
  menuIsOpen: PropTypes.bool,
  role: PropTypes.string,
  accountActions: PropTypes.object,
  skinActions: PropTypes.object,
  connectionActions: PropTypes.object,
  contentActions: PropTypes.object,
  customer: PropTypes.object,
  classrooms: PropTypes.object,
  layoutSettings: PropTypes.object,
  themeColors: PropTypes.object,
  loaded: PropTypes.any,
  loadedSchoolInfo: PropTypes.bool,
  user: PropTypes.object,
  router: PropTypes.object,
  classroom: PropTypes.object,
  children: PropTypes.any,
  colors: PropTypes.object,
  drawerActions: PropTypes.object,
  drawer: PropTypes.object,
  activeLoader: PropTypes.bool,
  classroomActions: PropTypes.object,
  connectionStatus: PropTypes.object,
  errorActions: PropTypes.object,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  trackingIdGAnalytics: PropTypes.string,
  googleMeetClientId: PropTypes.string,
  jitsiDomain: PropTypes.string,
  cookiesInfoUrl: PropTypes.string,
  enableHomeView: PropTypes.bool,
  classroomTabs: PropTypes.array
};

function mapStateToProps(state) {
  return {
    platformName: state.account.configuration.platformName,
    cookiesInfoUrl: state.account.configuration.cookiesInfoUrl,
    trackingIdGAnalytics: state.account.configuration.trackingIdGAnalytics,
    googleMeetClientId: state.account.configuration.meetClientId,
    jitsiDomain: state.account.configuration.jitsiDomain,
    router: state.router,
    menuIsOpen: state.components.menuIsOpen,
    role: state.account.user.role,
    activeClassrooms: state.classrooms.activeClassrooms,
    selectedClassroom: state.classrooms.selectedClassroom.classroom,
    classroomsFetching: state.classrooms.fetching,
    customer: state.school.school.customer,
    loadedSchoolInfo: state.school.loadedSchoolInfo,
    colors: state.theme.colors,
    layoutSettings: state.theme.layoutSettings,
    themeColors: state.theme.colors,
    loaded: state.theme.loaded,
    user: state.account.user,
    drawer: state.drawer,
    classrooms: state.classrooms,
    activeLoader: state.components.activeLoader,
    connectionStatus: state.connection.status,
    enableHomeView: state.account.configuration.enableHomeView,
    classroomTabs: state.account.configuration.classroomTabs,
    isJailed: state.account.jailed
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    errorActions: bindActionCreators(errorActions, dispatch),
    connectionActions: bindActionCreators(connectionActions, dispatch),
    contentActions: bindActionCreators(contentActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    customerTranslationsActions: bindActionCreators(customerTranslationsActions, dispatch)
  };
}
